import { Helmet } from 'react-helmet-async'
import React from 'react'

export const GoogleAnalyticsPixel: ({
  trackingId
}: {
  trackingId: string
}) => React.JSX.Element = ({ trackingId }: { trackingId: string }) => {
  return (
    <Helmet>
      {/*Google tag (gtag.js)*/}
      <script
        async
        src='https://www.googletagmanager.com/gtag/js?id=${trackingId}'
      ></script>
      <script>
        {`window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', '${trackingId}');`}
      </script>
    </Helmet>
  )
}
